import * as firebase from 'firebase';
import feathersClient from './feathers-client';
const firebaseConfig = {
    apiKey: 'AIzaSyBpqfnmsWlgvb57YNBQMLriO5R6F7Tq0s4',
    authDomain: 'bankshift-61a9c.firebaseapp.com',
    databaseURL: 'https://bankshift-61a9c-default-rtdb.europe-west1.firebasedatabase.app/',
    projectId: 'bankshift-61a9c',
    storageBucket: 'bankshift-61a9c.appspot.com',
    messagingSenderId: '776693508400',
    appId: '1:776693508400:ios:ba106c405bc3dacf9ac0f5',
};

firebase.initializeApp(firebaseConfig);

export const initFirebaseDbConnection = async () => {
    const db = await firebase.firestore();
    return db;
};

let hasSubscribeToTokenChange = false;

const firebaseAuth = async () => {
    const result = await feathersClient.service('/api/v3/firebase-token').find({
    });
    const credential = await firebase.auth().signInWithCustomToken(result.token);
    if (!hasSubscribeToTokenChange) {
        hasSubscribeToTokenChange = true;
        firebase.auth().onIdTokenChanged((user) => {
            if (!user) {
                credential.user.getIdToken(true);
            }
        });
    }
};

export {
    firebaseAuth,
};
